import web from '@/core/middlewares/web'

let services = () => import(/* webpackChunkName: "services" */ '@/views/services/Index');
let GeneralReport = () => import(/* webpackChunkName: "services" */ '@/views/services/GeneralReport');
let Financial = () => import(/* webpackChunkName: "services" */ '@/views/services/Financial');
let DomainSettings = () => import(/* webpackChunkName: "services" */ '@/views/services/DomainSettings');
let Server = () => import(/* webpackChunkName: "services" */ '@/views/services/Server');
let MarketPlace = () => import(/* webpackChunkName: "services" */ '@/views/services/MarketPlace.vue');
let Template = () => import(/* webpackChunkName: "services" */ '@/views/services/Template');
let Renew = () => import(/* webpackChunkName: "services" */ '@/views/services/Renew');
let Events = () => import(/* webpackChunkName: "services" */ '@/views/services/Events');
let Application = () => import(/* webpackChunkName: "services" */ '@/views/services/application/Index');
let CreateApplication = () => import(/* webpackChunkName: "services" */ '@/views/services/application/Create');
let Reset = () => import(/* webpackChunkName: "services" */ '@/views/services/Reset.vue');
let Emails = () => import(/* webpackChunkName: "emails" */ '@/views/services/emails/Index');
let CreateEmail = () => import(/* webpackChunkName: "emails" */ '@/views/services/emails/Create');
let CreditTransactions = () => import(/* webpackChunkName: "services" */ '@/views/services/CreditTransactions');


export default [
    {
        path: "/services",
        name: "services.index",
        component: services,
        meta: {
            middleware: web,
            title: "لیست سرویس ها"
        },
    },
    {
        path: "services/:service/renew",
        name: "services.renew",
        component: Renew,
        meta: {
            middleware: web,
            title: "تمدید سرویس"
        },
    },
    {
        path: "/services",
        component: () => import("@/views/services/Layout"),
        children: [
            {
                path: ":service",
                name: "services.generalReport",
                components: {
                    services: GeneralReport
                },
                meta: {
                    middleware: web,
                    title: "گزارش کلی"
                },
            },
            {
                path: ":service/invoices",
                name: "services.invoices",
                components: {
                    services: Financial
                },
                meta: {
                    middleware: web,
                    title: "مالی"
                },
            },
            {
                path: ":service/template",
                name: "services.template",
                components: {
                    services: Template
                },
                meta: {
                    middleware: web,
                    title: "انتخاب طرح"
                },
            },
            {
                path: ":service/domain",
                name: "services.domainSettings",
                components: {
                    services: DomainSettings
                },
                meta: {
                    middleware: web,
                    title: "تنظیمات دامنه"
                },
            },
            {
                path: ":service/server",
                name: "services.server",
                components: {
                    services: Server
                },
                meta: {
                    middleware: web,
                    title: "سرور"
                },
            },
            {
                path: ":service/marketplace",
                name: "services.marketplace",
                components: {
                    services: MarketPlace
                },
                meta: {
                    middleware: web,
                    title: "افزونه ها"
                },
            },
            {
                path: ":service/events",
                name: "service.events",
                components: {
                    services: Events
                },
                meta: {
                    middleware: web,
                    title: "رخداد ها"
                },
            },
            {
                path: ":service/credit-transactions",
                name: "service.credit_transactions",
                components: {
                    services: CreditTransactions
                },
                meta: {
                    middleware: web,
                    title: "تاریخچه الماس"
                },
            },
            {
                path: ":service/application",
                name: "service.application",
                components: {
                    services: Application
                },
                meta: {
                    middleware: web,
                    title: "اپلیکیشن موبایل"
                },
            },
            {
                path: ":service/application/create",
                name: "service.application.create",
                components: {
                    services: CreateApplication
                },
                meta: {
                    middleware: web,
                    title: "ایجاد اپلیکیشن موبایل"
                },
            },
            {
                path: ":service/reset",
                name: "service.reset",
                components: {
                    services: Reset
                },
                meta: {
                    middleware: web,
                    title: "حذف اطلاعات"
                },
            },
            {
                path: ":service/emails",
                name: "service.emails",
                components: {
                    services: Emails
                },
                meta: {
                    middleware: web,
                    title: "ایمیل ها"
                }
            },
            {
                path: ":service/emails/create",
                name: "services.email.create",
                components: {
                    services: CreateEmail
                },
                meta: {
                    middleware: web,
                    title: "ایجاد ایمیل"
                }
            },

        ]
    },
]
